import script from "./WrapperDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./WrapperDropdown.vue?vue&type=script&setup=true&lang=js"

import "./WrapperDropdown.vue?vue&type=style&index=0&id=1a8b0abe&lang=scss"

const __exports__ = script;

export default __exports__